export default __webpack_public_path__ + "static/media/screen4.9400bf64.png";